type ShowRange = Readonly<{
  minDays?: number;
  maxDays?: number;
}>;

type PriceAlertPayload = Readonly<{
  showRanges: ReadonlyArray<ShowRange>;
}>;

const isShowRange = (value: unknown): value is ShowRange => {
  if (typeof value !== 'object' || value === null) return false;
  const hasMin = 'minDays' in value;
  const hasMax = 'maxDays' in value;
  if (!hasMin && !hasMax) return false;
  return (!hasMin || typeof (value as ShowRange).minDays === 'number') && (!hasMax || typeof (value as ShowRange).maxDays === 'number');
};

const isPriceAlertPayload = (value: unknown): value is PriceAlertPayload =>
  typeof value === 'object' &&
  value !== null &&
  'showRanges' in value &&
  Array.isArray((value as PriceAlertPayload).showRanges) &&
  (value as PriceAlertPayload).showRanges.every(isShowRange);

export const isDaysInShowRanges = (daysUntilEvent: number | undefined, payload: unknown): boolean => {
  if (!isPriceAlertPayload(payload)) {
    // No valid payload → show for all days (backwards-compatible)
    return true;
  }

  const { showRanges } = payload;

  if (showRanges.length === 0) {
    // Empty array → show for all days
    return true;
  }

  if (daysUntilEvent === undefined) {
    // Unknown event date → don't gate on ranges, show the banner
    return true;
  }

  return showRanges.some(range => {
    const min = range.minDays ?? 0;
    const max = range.maxDays ?? Infinity;
    return daysUntilEvent >= min && daysUntilEvent <= max;
  });
};
